class ClausPopCarousel extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    if (!this.track || !this.slides.length) return;
    this.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-carousel-goto]');
      if (dot) this.go(Number(dot.dataset.carouselGoto));
      if (event.target.closest('[data-carousel-prev]')) this.go(this.index - 1);
      if (event.target.closest('[data-carousel-next]')) this.go(this.index + 1);
    }, { signal });
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, { signal });
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }, { signal, passive: true });
    this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this.track);
    if (this.hasAttribute('data-auto-height')) this.slides.forEach((slide) => this.resize.observe(slide));
    this.update();
  }
  disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); cancelAnimationFrame(this.frame); }
  go(index) {
    const slide = this.slides[Math.max(0, Math.min(this.slides.length - 1, index))];
    const rect = slide.getBoundingClientRect(), track = this.track.getBoundingClientRect();
    this.track.scrollTo({ left: this.track.scrollLeft + rect.left - track.left - (track.width - rect.width) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  update() {
    const box = this.track.getBoundingClientRect();
    this.dataset.static = String(this.track.scrollWidth <= this.track.clientWidth + 2);
    const center = box.left + box.width / 2;
    let nearest = Infinity;
    this.slides.forEach((slide, i) => {
      const r = slide.getBoundingClientRect(), distance = Math.abs(r.left + r.width / 2 - center);
      if (distance < nearest) { nearest = distance; this.index = i; }
    });
    if (this.track.scrollLeft <= 2) this.index = 0;
    if (this.track.scrollWidth > this.track.clientWidth + 2 && this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) this.index = this.slides.length - 1;
    if (this.hasAttribute('data-auto-height')) {
      const height = `${Math.ceil(this.slides[this.index].getBoundingClientRect().height)}px`;
      if (this.track.style.height !== height) this.track.style.height = height;
    }
    this.querySelectorAll('[data-carousel-goto]').forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.carouselGoto) === this.index)));
    const prev = this.querySelector('[data-carousel-prev]'), next = this.querySelector('[data-carousel-next]');
    if (prev) prev.disabled = this.track.scrollLeft <= 2;
    if (next) next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    this.slides.forEach((slide, i) => { if (i !== this.index) slide.querySelectorAll('video').forEach((video) => video.pause()); });
  }
}
if (!customElements.get('cp-carousel')) customElements.define('cp-carousel', ClausPopCarousel);

// Keep the cart link useful when a merchant hides or removes the drawer section.
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-testid="cart-drawer-trigger"]') && !document.querySelector('#cart-drawer')) {
    event.preventDefault(); event.stopImmediatePropagation();
    location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  }
}, true);

// The drawer now lives in a removable section group. Opening it is preview-only.
if (window.Shopify?.designMode) {
  const openCart = () => customElements.whenDefined('theme-drawer').then(() => document.querySelector('#cart-drawer')?.open());
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector?.('[data-cp-cart-section]')) openCart();
  });
  const previewCart = () => {
    if (document.querySelector('[data-cp-cart-section][data-editor-preview="true"]')) openCart();
  };
  document.addEventListener('shopify:section:load', previewCart);
  previewCart();
}
